import type { DataTableRow } from '@/shared/ui/data-table';
import type { ReceiveConfirmLineDto, ReceiveConvoyContextDto, ReceiveConvoyShipmentDto } from '@/entities/receive';

/**
 * One row of the convoy table. The shared table is flat, so each truck is laid
 * out as a run of rows: its header, its consignment lines, then its documents
 * (transport document and comments — stored once per receipt, not per line).
 */
export type ReceiveConvoyTableRow = DataTableRow & {
  shipment: ReceiveConvoyShipmentDto;
  shipmentIndex: number;
} & ({ kind: 'truck' } | { kind: 'line'; line: ReceiveConfirmLineDto; lineIndex: number } | { kind: 'documents' });

export const buildConvoyTableRows = (context: ReceiveConvoyContextDto): ReceiveConvoyTableRow[] =>
  context.shipments.flatMap((shipment, shipmentIndex) => [
    { id: `${shipment.shipmentId}:truck`, kind: 'truck' as const, shipment, shipmentIndex },
    ...shipment.lines.map((line, lineIndex) => ({
      id: line.lineId,
      kind: 'line' as const,
      shipment,
      shipmentIndex,
      line,
      lineIndex
    })),
    { id: `${shipment.shipmentId}:documents`, kind: 'documents' as const, shipment, shipmentIndex }
  ]);
